module.exports = __webpack_public_path__ + "img/DisplayX19229.f7d3077c.svg";